import { Controller } from "@hotwired/stimulus"

// Brand color field: preset swatches + a native color picker that stay in sync,
// with a live hex readout and an active-state on the matching preset.
//
// data-controller="color-field"
//   <input type="color" data-color-field-target="input" data-action="input->color-field#sync">
//   <output data-color-field-target="value"></output>
//   <button data-action="color-field#pick" data-color="#7a3fb2">…</button>
export default class extends Controller {
  static targets = ["input", "value"]

  connect() {
    this.render()
  }

  // A preset swatch was clicked — push its color into the picker and fire `input`
  // so the picker and any external listeners (e.g. a live brand preview) react
  // exactly as if the picker itself had changed.
  pick(event) {
    this.inputTarget.value = event.currentTarget.dataset.color
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  // The native picker changed.
  sync() {
    this.render()
  }

  render() {
    const value = (this.inputTarget.value || "").toLowerCase()
    if (this.hasValueTarget) this.valueTarget.textContent = value.toUpperCase()
    this.element.querySelectorAll("[data-color]").forEach((swatch) => {
      swatch.classList.toggle("is-active", swatch.dataset.color.toLowerCase() === value)
    })
  }
}
